import React from "react";
import Select from "react-select";
import { HiMiniUser } from "react-icons/hi2";
import { useInbox } from "../../contexts/inbox";
import { useAuth } from "../../contexts/auth";
import { formatInboxLabel } from "../Inbox/utils";

const InboxSelector = () => {
  const { user } = useAuth();
  const {
    individualInboxes,
    roles,
    inboxesByRole,
    selectedRoleId,
    inboxId,
    inbox,
    filteredInboxes,
    setSelectedRoleId,
    setSearchParams,
    setInbox,
    setSelectedFishThread,
    setThreads,
    setIsNewMessageOpen,
    setRoleInboxes
  } = useInbox();

  return (
    <Select
      options={[
        // First show the current user's inbox if it exists
        ...individualInboxes
          .filter(inbox => inbox.userId === user?.id)
          .map(inbox => ({
            value: inbox.id,
            label: (
              <div className="flex items-center">
                <span>{formatInboxLabel(inbox)}</span>
                <HiMiniUser className="ml-2 w-4 h-4 text-gray-600" />
              </div>
            ),
            isRole: false,
            isCurrentUser: true
          })),
        // Then show roles
        ...roles.map(role => ({
          value: `role-${role.id}`,
          label: `${role.name} (${role.inboxes.length} inboxes)`,
          isRole: true
        })),
        // Then show every other individual inbox (including ones that belong to roles)
        ...individualInboxes
          .filter(inbox => inbox.userId !== user?.id)
          .map(inbox => ({
            value: inbox.id,
            label: formatInboxLabel(inbox),
            isRole: false,
            isCurrentUser: false
          }))
      ]}
      value={
        selectedRoleId
          ? {
            value: `role-${selectedRoleId}`,
            label: `${roles?.find(g => g.id === selectedRoleId)?.name || 'Unknown Role'} (${inboxesByRole?.[selectedRoleId]?.length || 0} inboxes)`,
            isRole: true
          }
          : (filteredInboxes?.find(i => i.id === inboxId) && inbox
            ? {
              value: inboxId,
              label: inbox.userId === user?.id
                ? (
                  <div className="flex items-center">
                    <span>{formatInboxLabel(inbox)}</span>
                    <HiMiniUser className="ml-2 w-4 h-4 text-gray-600" />
                  </div>
                )
                : formatInboxLabel(inbox),
              isRole: false,
              isCurrentUser: inbox.userId === user?.id
            }
            : null)
      }
      onChange={(selectedOption) => {
        if (selectedOption.isRole) {
          // Selected a role
          const roleId = selectedOption.value.replace('role-', '');

          // Check if already on this role
          if (selectedRoleId === roleId) {
            // Already on this role, do nothing
            return;
          }

          setSelectedRoleId(roleId);
          setSearchParams({ roleId });
          setRoleInboxes(inboxesByRole[roleId] || []);

          // Clear inbox selection
          setInbox(null);
          setSelectedFishThread(null);
          setThreads([]);
          setIsNewMessageOpen(false);
        } else {
          // Selected an individual inbox

          // Check if already on this inbox
          if (inboxId === selectedOption.value) {
            // Already on this inbox, do nothing
            return;
          }

          setSelectedRoleId(null);
          setSearchParams({ inboxId: selectedOption.value });
          setSelectedFishThread(null);
          setThreads([]);
          setIsNewMessageOpen(false);
        }
      }}
      className="basic-single"
      classNamePrefix="select"
      placeholder="Select an inbox or role..."
      isSearchable={true}
    />
  );
};

export default InboxSelector;
